import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Header from '../Header';
import styled from 'styled-components';
import cloneDeep from 'clone-deep'; // needed when resetting state

import { withSearch } from '../SearchContext';

const RangeSliderContainer = styled.div`
  .input-range__track--active,
  .input-range__slider {
    background: ${props => props.color};
    border-color: ${props => props.color};
  }
`;

class Members extends Component {
  constructor() {
    super();

    this.handlePlace = this.handlePlace.bind(this);
    this.handleCity = this.handleCity.bind(this);
    this.handleSeeking = this.handleSeeking.bind(this);
  }

  // componentDidMount() {

  //   if (this.props.search.results.length > 0) {

  //   }
  // }

  handleCity(selectedValue) {
    selectedValue
      ? this.props.search.setCity(selectedValue.value)
      : this.props.search.setCity('None');
  }

  handlePlace() {
    this.props.search.setSeeking('stay');

    const headers = {
      'Content-Type': 'application/json'
    };

    const data = {
      country: this.props.search.countrySelected,
      seeking: 'stay',
      numGuests: 1,
      'start-date': this.props.search.startDate.format('DD/MM/YYYY'),
      'end-date': this.props.search.endDate.format('DD/MM/YYYY')
    };

    axios
    .post('/api/search', data, headers)
    .then(response => {
      this.props.search.setResults(response.data);
      this.props.history.push('/search');
    })
    .catch(function(error) {
      console.log('Request failure: ', error);
    });
  }

  handleSeeking(event) {
    this.props.search.setSeeking(event.target.value)
  }

  render() {
    if (this.props.search.results.length < 1) return <p>No Results</p>;


    /**
     * Apply filters and generate results for display
     */
    let members = this.props.search.results
      // filter by city
      .filter(m => {
        return this.props.search.city === 'None'
          ? true
          : m.county === this.props.search.city;
      })
      // filter by seeking
      .filter(m => {
        return m[this.props.search.seeking] === 1;
      });


    // Wrap pairs of results in a div for styling, probably a more elegant way to do this
    let results = [];
    for (let i = 0; i < members.length; i += 2) {
      results.push(
        <div key={members[i].id} className="row pb-30">
          <ResultCard
            id={members[i].id}
            city={members[i].city}
            county={members[i].county}
            fullName={members[i].full_name}
            profilePhoto={members[i].profilePhotoO}
            interests={members[i].interests}
          />
          {i + 1 < members.length ? (
            <ResultCard
              id={members[i + 1].id}
              city={members[i + 1].city}
              county={members[i + 1].county}
              fullName={members[i + 1].full_name}
              profilePhoto={members[i + 1].profilePhotoO}
              interests={members[i + 1].interests}
            />
          ) : null}
        </div>
      );
    }

    /**
     * Prepare the options for the city filter (sort and remove duplicate cities)
     */
    const cities = this.props.search.results.map(p => {
      return p.county; // TODO check if this should be cities or counties or ?
    });
    const dedupedCities = [...new Set(cities)];
    dedupedCities.sort();
    const cityOptions = dedupedCities.map(c => {
      return { label: c, value: c };
    });

    return (
      <section id="packages_grid_items" className="packages tours_grid">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="sub-title">
                <h2>Find a member</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4">
              {/* <SearchForm /> */}

              <CityFilter
                cityOptions={cityOptions}
                handleCity={this.handleCity}
              />

              <SeekingFilter
                seeking={this.props.search.seeking}
                handleSeeking={this.handleSeeking}
                handlePlace={this.handlePlace}
              />

            </div>
            <div className="col-sm-12 col-md-12 col-lg-8">
              <SortControl members={members} />

              {results}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const ResultCard = props => (
  <div className="col-sm-6 single-package-wrapper">
    <div className="singel-packages">
      <div className="img-wrapper">
        <div className="row">
          <div className="col-12">
          <Link to={`/user/${props.id}`}>
            <img
              // src={`${s3AwsEndpoint}/${props.profilePhoto}`}
              // src={`https://s3-eu-west-1.amazonaws.com/freebird-uploads-production/${props.profilePhoto}`}
              // src="http://s3-eu-west-1.amazonaws.com/freebird-uploads-production/gfx/users/photo_l/1471635474720IMG_0348.JPG"
              src={`${s3AwsEndpoint}/${props.profilePhotoO}`}
              alt={`${props.fullName} profile photo`}
              className="img-fluid"
            />
            </Link>
          </div>
        </div>
      </div>
      <div className="packages-title">
        <div className="title-wrapper">
          <h3>
            <Link to={`/user/${props.id}`}>{`${
              props.fullName
            }`}</Link>
          </h3>
          <p>{`${props.city}, ${props.county}`}</p>
          <p>{props.interests}</p>
        </div>
      </div>
    </div>
  </div>
);

const SortControl = props => (
  <div className="col-sm-12">
    <div className="shorting_wrapper">
      <p>
        Showing 1-{props.members.length} of {props.members.length} results{' '}
      </p>
    </div>
  </div>
);

const CityFilter = props => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: '#f5f6f7',
      border: 'none',
      borderRadius: '0px',
      height: '52px'
    })
  };
  return (
    <div className="booking-form-wrapper pb-50">
      <form>
        <div className="form-group">
          <div className="form-items">
            <div className="form-single">
              <label>Filter by city</label>
              <Select
                placeholder="City..."
                defaultValue={''}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="city"
                options={props.cityOptions}
                onChange={props.handleCity}
              />
            </div>

            {/* <div className="form-single">
              <div className="search-btn d-flex justify-content-end">
                <button className="btn-primary" type="button">
                  Refine
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </form>
    </div>
  );
};

const SeekingFilter = props => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: '#f5f6f7',
      border: 'none',
      borderRadius: '0px',
      height: '52px'
    })
  };
  return (
    <div className="booking-form-wrapper pb-50">
      <form>
        <div className="form-group">
          <div className="form-items">
            <div className="form-single">
                <label>What are you seeking?</label>

                <div className="form-check form-check-inline col-sm-12 mt-2">
                  <input className="form-check-input" type="radio" id="advice" value="advice" onChange={props.handleSeeking} checked={props.seeking === 'advice'} />
                  <label className="form-check-label" htmlFor="advice">
                  Advice from local members
                  </label>
                </div>
                <div className="form-check form-check-inline col-sm-12">
                  <input className="form-check-input" type="radio" id="meetup" value="meetup" onChange={props.handleSeeking} checked={props.seeking === 'meetup'} />
                  <label className="form-check-label" htmlFor="meetup">
                  Meet local members
                  </label>
                </div>
                <div className="form-check form-check-inline col-sm-12 mt-4">
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={props.handlePlace}>
                  Want a place to stay?
                </button>

                </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const ResultsPagination = () => (
  // TODO convert hrefs to <Link>
  <div className="col-sm-12">
    <nav aria-label="Page navigation">
      <ul className="pagination">
        <li className="page-item">
          <a className="page-link" href="#" aria-label="Previous">
            <span aria-hidden="true">
              <i className="fa fa-angle-left" />
            </span>
            <span className="sr-only">Previous</span>
          </a>
        </li>
        <li className="page-item active">
          <a className="page-link active" href="#">
            1
          </a>
        </li>
        <li className="page-item">
          <a className="page-link" href="#">
            2
          </a>
        </li>
        <li className="page-item">
          <a className="page-link" href="#">
            3
          </a>
        </li>
        <li className="page-item">
          <a className="page-link" href="#" aria-label="Next">
            <span aria-hidden="true">
              <i className="fa fa-angle-right" />
            </span>
            <span className="sr-only">Next</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
);

export default withSearch(Members);
